import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { debounce } from 'lodash';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as EventsActions, Selectors as EventsSelectors } from 'store/ducks/events';

import { Validate } from 'common';
import { Page, Breadcrumbs, Form, Icon } from 'components';

class Invite extends Component {
  state = {
    data: {
      event: '',
      resend: false,
      passions: [],
      documents: '',
    },
    errors: {},
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Eventos', to: '/events' },
      { name: 'Lista de Eventos', to: '/events/list' },
      { name: 'Convidar', to: '' },
    ],
    collapses: {
      interests: false,
      invites: false,
    },
  };

  constructor(props) {
    super(props);

    const { getEventPassionsRequest } = props;

    this.handleSearchPassion = debounce(getEventPassionsRequest, 300);
  }

  componentDidMount() {
    const { getEventPassionsRequest } = this.props;
    const { getEventRequest } = this.props;

    getEventPassionsRequest();
    getEventRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { event } = this.props;

    if (oldProps.event.loading && !event.loading) {
      this.setState({
        data: {
          id: event.data.id,
          event: event.data.attributes.name,
        },
      });
    }
  }

  handleGetID = () => {
    const { location } = this.props;

    const match = matchPath(location.pathname, { path: '/events/:id/invite' });
    const { id } = match.params;
    return id;
  };

  handleChange = data => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate(); // criar o metódo validade
  };

  handleFindPassion = value => {
    this.handleSearchPassion(value);
  };

  handleSelectPassions = value => {
    const { data } = this.state;

    this.setState({
      data: { ...data, passions: value },
    });
  };

  handleToggle = name => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: !data[name] } });
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      event: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleChangeInput = e => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleToggleCollapses = (name, e) => {
    e.preventDefault();
    const { collapses } = this.state;

    this.setState({ collapses: { ...collapses, [name]: !collapses[name] } });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { data } = this.state;
    const { inviteEventRequest } = this.props;

    if (!this.handleValidate()) return null;

    inviteEventRequest(this.handleGetID(), {
      documents: data.documents.split('\n').map(document => document.trim()),
      passion_ids: data.passions.map(passion => passion.value),
      resend: data.resend,
    });
  };

  render() {
    const { data, errors, breadcrumbs, collapses } = this.state;
    const { passions, event } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form className="page-form" onSubmit={this.handleSubmit}>
          <h3 className="form-title">Convidar Participantes</h3>

          <Form.Field>
            <Form.Label>Evento</Form.Label>
            <Form.Input
              name="event"
              placeholder="Desconto em produtos para Piscina"
              value={data.event}
              onChange={this.handleChangeInput}
              errors={errors.event}
            />
          </Form.Field>

          <div className="form-section">
            <h4 className="form-section-title">
              Interesses
              <button className="form-section-toggler" onClick={e => this.handleToggleCollapses('interests', e)}>
                <Icon name={collapses.interests ? 'caret-up' : 'caret-down'} prefix="fa" />
              </button>
            </h4>

            <div className={`form-section-collapse ${collapses.interests ? 'open' : ''}`}>
              <Form.Field className="field-select">
                <Form.Label>Interesses</Form.Label>
                <Form.Select
                  isMulti
                  placeholder="Interesses"
                  noOptionsMessage={() => 'Procurar interesses'}
                  options={passions.data}
                  onInputChange={this.handleFindPassion}
                  onChange={this.handleSelectPassions}
                  value={data.passions}
                />
              </Form.Field>
            </div>
          </div>

          <div className="form-section margin-bottom-40">
            <h4 className="form-section-title">
              Convites individuais
              <button className="form-section-toggler" onClick={e => this.handleToggleCollapses('invites', e)}>
                <Icon name={collapses.invites ? 'caret-up' : 'caret-down'} prefix="fa" />
              </button>
            </h4>

            <div className={`form-section-collapse ${collapses.invites ? 'open' : ''}`}>
              <Form.Field>
                <Form.Label>Enviar para CPFs específicos</Form.Label>
                <Form.TextArea
                  name="documents"
                  value={data.documeents}
                  placeholder="Digite 1 CPF por linha, somente números"
                  onChange={this.handleChangeInput}
                />
              </Form.Field>
            </div>
          </div>

          <Form.Field className="checkbox-field">
            <Form.Label>
              Permitir Reenvio
              <small>Permitir reenvio para clientes já convidados</small>
            </Form.Label>
            <Form.Checkbox checked={data.resend} onChange={() => this.handleToggle('resend')} />
          </Form.Field>

          <div className="buttons">
            <Link to={`/events/${event.data.id}/edit`} className="button-cancel">
              Voltar
            </Link>
            {/* <Link to={`/events/${event.data.id}/edit`} className="button-save">
              Enviar
            </Link> */}
            <Form.Button className="button-save" onClick={this.handleSubmit}>
              Enviar
            </Form.Button>
          </div>
        </Form>
      </Page>
    );
  }
}

const mapState = state => ({
  event: state.events.detail,
  passions: {
    ...state.events.passions,
    data: EventsSelectors.passions(state.events.passions.data),
  },
});

const mapActions = dispatch => bindActionCreators(EventsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Invite);
